import { Button, Card, Col, Row, Tag } from "antd";
import React from "react";
import {
  convertMsToHoursMinutes,
  formatDate,
  formatDateWithDay,
} from "../../../../shared/helpers";
import { TimesheetActionButtonCol } from "../TimesheetActionButtonCol/TimesheetActionButtonCol";
import "./index.css";
import moment from "moment";
import { FileTextOutlined } from "@ant-design/icons";
import { TIME_SHEET_PENDING_ACTION } from "../../TimeSheetConstants";
const TimeOffListCard = ({
  data,
  handleApproveRejectClick,
  handleShowReason,
}) => {
  const { fromDate, toDate, type, status, days } = data;
  return (
    <Card>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={13} className="left-col-timesheetList">
              From
            </Col>
            <Col span={11}>{formatDateWithDay(fromDate)}</Col>
          </Row>
          <Row>
            <Col span={13} className="left-col-timesheetList">
              Date
            </Col>
            <Col span={11}>{formatDateWithDay(toDate) || ""}</Col>
          </Row>
          <Row>
            <Col span={13} className="left-col-timesheetList">
              Days
            </Col>
            <Col span={11}>{days}</Col>
          </Row>
          <Row>
            <Col span={13} className="left-col-timesheetList">
              Time Off Type
            </Col>
            <Col span={11}>{type || "N/A"}</Col>
          </Row>
          <Row>
            <Col span={13} className="left-col-timesheetList">
              Time Off Reason
            </Col>
            <Col span={11}>
              <Button
                style={{
                  border: "transparent !important",
                  background: "transparent !important",
                }}
                onClick={() => handleShowReason(data)}
                disabled={data?.status !== TIME_SHEET_PENDING_ACTION}
                type="ghost"
                icon={
                  <FileTextOutlined
                    style={{ color: "#888888", cursor: "pointer" }}
                  />
                }
              />
            </Col>
          </Row>
          <TimesheetActionButtonCol
            status={status}
            handleApprove={() => handleApproveRejectClick(data)}
            handleReject={() => handleApproveRejectClick(data)}
          />
        </Col>
      </Row>
    </Card>
  );
};

export { TimeOffListCard };
